import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MissingServicesNotificationProps {
  onAddServices: () => void;
  className?: string;
}

const MissingServicesNotification: React.FC<
  MissingServicesNotificationProps
> = ({ onAddServices, className = '' }) => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      className={`w-full rounded-lg border border-amber-200 bg-amber-50 p-3 dark:border-amber-800 dark:bg-amber-900/20 ${className}`}
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
          <div className="min-w-0 flex-1">
            <h3 className="mb-1 text-sm font-semibold text-amber-900 dark:text-amber-100">
              {t(
                'agent.page.missing_services.title.translation',
                'Add your services'
              )}
            </h3>
            <p className="text-xs text-amber-800 dark:text-amber-200">
              {t(
                'agent.page.missing_services.message.translation',
                'Your plan includes the calendar and bookings. Add services so the agent can answer pricing and duration questions, and so you can take appointments.'
              )}
            </p>
          </div>
        </div>
        <Button
          type="button"
          variant="brand"
          size="sm"
          onClick={onAddServices}
          className="shrink-0 self-start sm:self-center"
        >
          {t(
            'agent.page.missing_services.action.translation',
            'Add services'
          )}
        </Button>
      </div>
    </div>
  );
};

export default MissingServicesNotification;
